import { render, staticRenderFns } from "./ChatRecent.vue?vue&type=template&id=edd9da60&scoped=true&"
import script from "./ChatRecent.vue?vue&type=script&lang=ts&"
export * from "./ChatRecent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatRecent.vue?vue&type=style&index=0&id=edd9da60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd9da60",
  null
  
)

export default component.exports